import { render, staticRenderFns } from "./configuracao-pessoa.vue?vue&type=template&id=f82adb1c&scoped=true"
import script from "./configuracao-pessoa.vue?vue&type=script&lang=ts"
export * from "./configuracao-pessoa.vue?vue&type=script&lang=ts"
import style0 from "./configuracao-pessoa.vue?vue&type=style&index=0&id=f82adb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82adb1c",
  null
  
)

export default component.exports